import CardContent from "@mui/material/CardContent";
import {Button, List, ListItem, ListItemIcon, ListItemText, Stack, Typography} from "@mui/material";
import CardActions from "@mui/material/CardActions";
import Card from "@mui/material/Card";
import React from "react";
import {BundleType} from "./BundlesList";
import {useNavigate} from "react-router-dom";
import I18n from "i18n-js";
import {Spacer} from "../../../common";
import {green, red} from '@mui/material/colors';
import CheckIcon from "@mui/icons-material/Check";

export interface PackageCardProps {
  id: number;
  type: BundleType;
  price: number;
  name: string;
  user_limit: number;
  waiver_limit: number;
  storage_limit: number;
  submit_limit: number;
  location_limit: number;
}


export default function PackageCard(
  {
    id,
    type,
    price,
    name,
    user_limit,
    waiver_limit,
    storage_limit,
    submit_limit,
    location_limit,
  }: PackageCardProps
) {
  const navigate = useNavigate();

  function orderClick() {
    navigate("/order", {
      state: {
        bundleId: id,
        bundleName: name,
        bundleType: type,
        userLimit: user_limit,
        waiverLimit: waiver_limit,
        storageLimit: storage_limit,
        submitLimit: submit_limit,
        locationLimit: location_limit,
      },
    });
  }

  return (
    <Card sx={{minWidth: 275}}>
      <CardContent>
        <Typography
          variant="h3"
          component="div"
          sx={{
            textAlign: "center",
          }}
        >
          {name}
        </Typography>
        <Spacer h={1}/>
        <Stack alignItems="center">
          <Typography variant="h4" fontWeight="bold">
            ${price}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            per {I18n.t("MyAccount.pages.billingAndPlans.bundlesPer." + type.toLowerCase())}
          </Typography>
        </Stack>
        <Spacer h={2}/>
        <List>
          <ListItem sx={{paddingBottom: "4px", paddingTop: "4px"}}>
            <ListItemIcon sx={{minWidth: "30px"}}>
              <CheckIcon sx={{color: green[600], fontSize: 18}}/>
            </ListItemIcon>
            <ListItemText
              primary={`Up to ${user_limit} user`}
            />
          </ListItem>

          <ListItem sx={{paddingBottom: "4px", paddingTop: "4px"}}>
            <ListItemIcon sx={{minWidth: "30px"}}>
              <CheckIcon sx={{color: green[600], fontSize: 18}}/>
            </ListItemIcon>
            <ListItemText primary={`Up to ${waiver_limit} waiver`}/>
          </ListItem>

          <ListItem sx={{paddingBottom: "4px", paddingTop: "4px"}}>
            <ListItemIcon sx={{minWidth: "30px"}}>
              <CheckIcon sx={{color: green[600], fontSize: 18}}/>
            </ListItemIcon>
            <ListItemText primary={`Up to ${storage_limit} storage`}/>
          </ListItem>

          <ListItem sx={{paddingBottom: "4px", paddingTop: "4px"}}>
            <ListItemIcon sx={{minWidth: "30px"}}>
              <CheckIcon sx={{color: green[600], fontSize: 18}}/>
            </ListItemIcon>
            <ListItemText primary={`Up to ${submit_limit} submit`}/>
          </ListItem>

          <ListItem sx={{paddingBottom: "4px", paddingTop: "4px"}}>
            <ListItemIcon sx={{minWidth: "30px"}}>
              <CheckIcon sx={{color: green[600], fontSize: 18}}/>
            </ListItemIcon>
            <ListItemText primary={`Up to ${location_limit} location`}/>
          </ListItem>
        </List>
      </CardContent>
      <CardActions>
        <Button
          onClick={orderClick}
          size={"large"}
          sx={{ ml: 'auto' }}
        >{I18n.t("MyAccount.pages.billingAndPlans.choosePlan")}</Button>
      </CardActions>
    </Card>
  );
}